// Os textos dos Termos de Uso e da Política de Privacidade são publicados na landing,
// fora deste app; aqui só ficam os links. Configuráveis por env (embutidos no build).
export const TERMS_URL = process.env.REACT_APP_TERMS_URL || "https://lp.medstation.app/termos";
export const PRIVACY_URL =
  process.env.REACT_APP_PRIVACY_URL || "https://lp.medstation.app/privacidade";
